import "./App.css";
import desktop from "./assets/Desktop.png";
import window from "./assets/Window.png";
import korova from "./assets/Korova.png";
import volume from "./assets/Volume.png";
import trigger from "./assets/Volume_ind.png";
import telegram from "./assets/telegram.png";
import tiktok from "./assets/tiktok.png";
import twitter from "./assets/twitter.png";
import { Button } from "./components/Button";
import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";

const buttonsFooter = [
  {
    width: "165px",
    height: "50px",
    text: "Telegram",
    "font-size": "26px",
    img: telegram,
    link: "https://t.me/DumpyBullSOL1",
  },
  {
    width: "138px",
    height: "50px",
    text: "TikTok",
    "font-size": "26px",
    img: tiktok,
    link: "https://www.tiktok.com/@brehillboyette",
  },
  {
    width: "165px",
    height: "50px",
    text: "X (twitter)",
    "font-size": "26px",
    img: twitter,
    link: "https://x.com/DumpyBullSOL",
  },
];

const buttonsWindow = [
  {
    width: "240px",
    height: "78.6px",
    text: "Copy CA",
    "font-size": "35px",
    link: "",
    isCopy: true,
  },
  {
    width: "240px",
    height: "78.6px",
    text: "Buy on Raydium",
    "font-size": "35px",
    link: "https://raydium.io/swap/?outputCurrency=4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6RCfh25GX9wfV5NBnE2hzKP7UTugGvizBY35Evr8o4mmWF&inputMint=sol&outputMint=Dby4bVRzM3pHpoLWRzWLyWu2mGk3vtnzLTCjDfctpump",
  },
];

function App() {
  const [time, setTime] = useState(new Date());
  const playSound = () => {
    const audio = new Audio("/korova.mp3");
    audio.play();
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    console.log(
      time.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    );

    return () => clearInterval(timer);
  }, [time]);

  return (
    <div className="main">
       <img
          className="mobile"
          src={korova}
          alt="korova"
          draggable={false}
          onClick={playSound}
        />
      <a href="https://game.dumpybullsol.com" target="_blank">
      <img className="img" src={desktop} draggable={false} alt="desktop" />
      </a>
      <div className="windows_wrapper">
        <span className="window_title" style={{ top: "22px", left: "26px" }}>
          Solana
        </span>
        <img
          className="window"
          src={window}
          alt="window"
          draggable={false}
        ></img>
        <span className="window_title" style={{ top: "72px", left: "0" }}>
          Solana
        </span>
        <img
          className="window"
          style={{ top: "50px", left: "-26px" }}
          src={window}
          alt="window"
          draggable={false}
        ></img>
        <span className="window_text">
          Here should be some text, but since we didn't know what to write: cow
          = milk, bull = profits. But don't try to milk a bull. I did. That was
          bad.
        </span>
        <div className="buttons">
          {buttonsWindow.map((button, index) => (
            <Button data={button} />
          ))}
        </div>
        <img
          className="korova"
          src={korova}
          alt="korova"
          draggable={false}
          onClick={playSound}
        />
        <img
          className="trigger"
          src={trigger}
          alt="trigger"
          draggable={false}
          onClick={playSound}
        />
      </div>
      <div className="footer">
        <div className="footer_buttons">
          {buttonsFooter.map((button, index) => (
            <Button data={button} />
          ))}
        </div>
        <div className="time">
          <img src={volume} draggable={false} alt="volume" />
          {time.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}
        </div>
      </div>
    </div>
  );
}

export default App;
